import { ItemType } from "antd/es/menu/interface";
import React, { useMemo } from "react";
import { useTicketData } from "../..";
import { Project } from "../../../../js/parsegenerated";
import { ProjectTag } from "../components/ticket/ProjectTag";
import { useProjects } from "./useProjects";

export const useDropdownItems = () => {
  const { projects } = useProjects();
  const ticketData = useTicketData();

  const items: ItemType[] = useMemo(() => {
    const projectItems = projects
      .filter((project) => project.id !== ticketData.ticket.project?.id)
      .map((project: Project) => ({
        key: project.id,
        label: <ProjectTag project={project} clickable />,
        color: project.get("color"),
      }));

    const noProject = new Project({ objectId: "unset" });
    const noProjectItem = {
      key: "noProject",
      label: <ProjectTag project={noProject} clickable />,
      color: undefined,
    };

    projectItems.unshift(noProjectItem);
    return projectItems;
  }, [projects]);

  return items;
};
